const dependencies = importAngularDependencies(
  require.context('./', true, /\.js/),
  './global.common.js'
);

export default angular.module('doxy.global.common', dependencies).name;
